<div class="stepper-body">
    <div class="body-title">
        <span>What is your annual income?</span>
    </div>
    <div class="body-description">
        <span>Please enter an average over the last two years, including base pay, bonuses, commissions, contract work,
            and any regular support income.</span>
    </div>
    <div class="body-answers custom-answers">
        <div class="custom-container">
            <form [formGroup]="formGroup">
                <div class="input-container">
                    <mat-form-field appearance="outline" class="step-input">
                        <span matPrefix>$&nbsp;</span>
                        <input matInput currencyMask [options]="currencyOptions" [formControlName]="StatedIncomeInputs.Income" [required]="true" />
                        <mat-error *ngIf="formGroup.get(StatedIncomeInputs.Income)?.touched
                                        && formGroup.get(StatedIncomeInputs.Income)?.hasError('required')">
                            {{ StatedIncomeInputs.Income }} is required
                        </mat-error>
                        <mat-error *ngIf="formGroup.get(StatedIncomeInputs.Income)?.touched
                                        && formGroup.get(StatedIncomeInputs.Income)?.hasError('pattern')">
                            {{ StatedIncomeInputs.Income }} format is incorrect
                        </mat-error>
                    </mat-form-field>
                    <p class="body-description per-year"> / year</p>
                </div>
            </form>
        </div>
    </div>
</div>
<div class="stepper-footer">
    <mat-divider></mat-divider>
    <div class="step-controls">
        <button mat-stroked-button color="primary" (click)="onBack()"
            class="step-button secondary" [disabled]="false">
            Back
        </button>
        <button mat-flat-button color="primary" (click)="onNext()" class="step-button primary"
            [disabled]="isNextDisabled()">
            Next
        </button>
    </div>
</div>